import React from "react";
import { Box } from "@mui/material";
import { TwitterPicker } from "react-color";
import RefreshIcon from "@mui/icons-material/Refresh";
import TagChip from "../exercise-library/tags/TagChip";
import { colorSystem } from "../../theme";
import makeStyles from "@mui/styles/makeStyles";
import { generateRandomColor } from "../exercise-library/tags/ManageTagDialog";

interface TagColorPicker {
  name: string;
  color: string;
  onChange: (color: string) => void;
}

const useStyles = makeStyles((theme) => ({
  resetButtonContainer: {
    position: "absolute",
    bottom: 8,
    right: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: "50%",
    border: "1px solid",
    cursor: "pointer",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

//If you want to add or remove colors, ensure that reset button is aligned good with the picker
//since it is positioned absolutely in the parent container
const tagPickerColors = [
  colorSystem.red,
  colorSystem.orange,
  colorSystem.green2,
  colorSystem.blue2,
  colorSystem.purple2,
  colorSystem.nutritionFats,
  colorSystem.gray,
  colorSystem.gray2,
  colorSystem.gray7,
  colorSystem.blue1,
  colorSystem.orange3,
  colorSystem.blue3,
  colorSystem.gray1,
  colorSystem.gray11,
];

export const MAX_HEX_COLOR_VALUE = 16777215;

export const TagColorPicker: React.FC<TagColorPicker> = ({
  name,
  color,
  onChange,
}) => {
  const s = useStyles();

  const handleRandomColor = () => {
    onChange(generateRandomColor());
  };

  return (
    <Box display="flex" flexDirection="column" flexWrap="wrap" gap={2} mt={3}>
      <Box sx={{ position: "relative", width: "fit-content" }}>
        <TwitterPicker
          triangle="hide"
          sx={{ position: "relative" }}
          color={color}
          onChangeComplete={(c: { hex: string }) => onChange(c.hex)}
          colors={tagPickerColors}
        />

        <Box onClick={handleRandomColor} className={s.resetButtonContainer}>
          <RefreshIcon fontSize="small" />
        </Box>
      </Box>

      <TagChip text={name || "Tag name"} primaryColor={color} />
    </Box>
  );
};
